// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__q1s-w","employeeManagementTable":"style__employeeManagementTable__EgUUk"};